import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import Modal from '../../components/modal/modal.jsx';
import Loading from "../../components/loading/loading.jsx";
import axiosInstance from "../../api/axiosInstance.js";
import "./view.scss"
import PdfReader from "../../components/pdfReader/pdfReader.jsx";

const View = () => {

    const location = useLocation();

    const postSlug = location.pathname.split("/")[2];

    const [post, setPost] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isPdfReaderOpen, setPfdReaderOpen] = useState(false);

    const fetchData = useCallback(async () => {
        try {
            const [postRes] = await Promise.all([
                axiosInstance.get(`events/${postSlug}`)
            ]);
            setPost(postRes.data);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, [postSlug]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const closeModal = () => {
        setModalOpen(false);
    };

    const closePdfReader = () => {
        setPfdReaderOpen(false);
    };

    return isLoading ? (<Loading />) : (
        <motion.div
            className="view"
            initial={{ scale: 0.9 }}
            whileInView={{ scale: 1 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
        >
            <Helmet>
                <title>{post.title} | wosgeat</title>
                <meta name="description" content={post.desc} />
            </Helmet>
            <Modal isOpen={isModalOpen} wine={post} closeModal={closeModal} />
            <PdfReader isOpen={isPdfReaderOpen} document={post.doc} closePdfReader={closePdfReader} />
            <div className="container">
                <div className="header">
                    <img src={"https://api.kolhaupt.it/uploads/" + post.img} alt={post.title} />
                </div>
                <h2>{post.title}</h2>
            </div>
            <div className="container">
                {post.doc && <button onClick={() => { setPfdReaderOpen(true) }}>PDF</button>}
            </div>
        </motion.div>
    )
};

export default View